import types from "./types";
import { IDLE, LOADING, SUCCESS, FAILURE } from "../common/status";
import { UPDATED_SENTIMENT_FEEDBACK } from "../../../Pages/Video/VideoActions";

const {
  VIDEO_ASSOCIATIONS_REQUEST,
  VIDEO_ASSOCIATIONS_SUCCESS,
  VIDEO_ASSOCIATIONS_FAILURE,
  VIDEO_ASSOCIATIONS_RESET,
  UPDATED_DROPBOX_DATA,
  UPDATED_API_DATA,
  SET_VIDEO_TRANSCRIPT,
} = types;

const INITIAL_STATE = {
  body: {},
  error: null,
  status: IDLE,
  statusText: "",
  statusCode: null,
  transcript: [],
};

export default function (state = INITIAL_STATE, action) {
  const { type, payload, transcript } = action;

  switch (type) {
    case VIDEO_ASSOCIATIONS_REQUEST:
      return {
        ...state,
        status: LOADING,
      };
    case VIDEO_ASSOCIATIONS_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        body: payload.data,
        statusCode: payload.status,
      };
    case VIDEO_ASSOCIATIONS_FAILURE:
      return {
        ...state,
        status: FAILURE,
        error: payload,
        statusText: payload.statusText,
        statusCode: payload.status,
      };
    case SET_VIDEO_TRANSCRIPT:
      return { ...state, transcript };
    case VIDEO_ASSOCIATIONS_RESET:
      return INITIAL_STATE;
    case UPDATED_DROPBOX_DATA:
      return { ...state, body: { video: payload } };
    case UPDATED_API_DATA:
      return { ...state, body: { video: payload } };
    case UPDATED_SENTIMENT_FEEDBACK:
      return {
        ...state,
        body: { ...state.body, sentiment_feedback_like: payload },
      };
    default:
      return state;
  }
}
